import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Panel, Alert, Button } from 'react-bootstrap';
import cx from 'classnames';
import { Save, MessageCircle } from 'lucide-react';

import s from './ChatFilterMessages.css';
import MultiLanguageInput from '../../../components/siteadmin/MultiLanguageInput';

class ChatFilterMessages extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            phoneMessage: '',
            phoneMessage_en: '',
            phoneMessage_fr: '',
            phoneMessage_it: '',
            phoneMessage_pt: '',
            emailMessage: '',
            emailMessage_en: '',
            emailMessage_fr: '',
            emailMessage_it: '',
            emailMessage_pt: '',
            urlMessage: '',
            urlMessage_en: '',
            urlMessage_fr: '',
            urlMessage_it: '',
            urlMessage_pt: '',
            loading: false,
            success: false,
            error: null,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        const { data } = this.props;
        if (data && !data.loading && prevProps.data?.loading) {
            this.loadData();
        }
    }

    loadData = () => {
        const { data } = this.props;
        if (data && data.getContentFilterMessages && data.getContentFilterMessages.status === 200) {
            const messages = data.getContentFilterMessages;
            this.setState({
                phoneMessage: messages.phoneMessage_es || '',
                phoneMessage_en: messages.phoneMessage_en || '',
                phoneMessage_fr: messages.phoneMessage_fr || '',
                phoneMessage_it: messages.phoneMessage_it || '',
                phoneMessage_pt: messages.phoneMessage_pt || '',
                emailMessage: messages.emailMessage_es || '',
                emailMessage_en: messages.emailMessage_en || '',
                emailMessage_fr: messages.emailMessage_fr || '',
                emailMessage_it: messages.emailMessage_it || '',
                emailMessage_pt: messages.emailMessage_pt || '',
                urlMessage: messages.urlMessage_es || '',
                urlMessage_en: messages.urlMessage_en || '',
                urlMessage_fr: messages.urlMessage_fr || '',
                urlMessage_it: messages.urlMessage_it || '',
                urlMessage_pt: messages.urlMessage_pt || '',
            });
        }
    };

    handleChange = (field, value) => {
        this.setState({ [field]: value, success: false, error: null });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { updateContentFilterMessages } = this.props;
        const {
            phoneMessage, phoneMessage_en, phoneMessage_fr, phoneMessage_it, phoneMessage_pt,
            emailMessage, emailMessage_en, emailMessage_fr, emailMessage_it, emailMessage_pt,
            urlMessage, urlMessage_en, urlMessage_fr, urlMessage_it, urlMessage_pt,
        } = this.state;

        this.setState({ loading: true, error: null, success: false });

        try {
            const { data } = await updateContentFilterMessages({
                variables: {
                    phoneMessage_es: phoneMessage,
                    phoneMessage_en,
                    phoneMessage_fr,
                    phoneMessage_it,
                    phoneMessage_pt,
                    emailMessage_es: emailMessage,
                    emailMessage_en,
                    emailMessage_fr,
                    emailMessage_it,
                    emailMessage_pt,
                    urlMessage_es: urlMessage,
                    urlMessage_en,
                    urlMessage_fr,
                    urlMessage_it,
                    urlMessage_pt,
                }
            });

            if (data.updateContentFilterMessages.status === 200) {
                this.setState({ success: true, loading: false });
                setTimeout(() => this.setState({ success: false }), 3000);
            } else {
                this.setState({ error: data.updateContentFilterMessages.errorMessage || 'Error al guardar', loading: false });
            }
        } catch (err) {
            this.setState({ error: err.message, loading: false });
        }
    };

    render() {
        const { title, data } = this.props;
        const { loading, success, error } = this.state;
        const isDataLoading = data && data.loading;

        return (
            <div className={s.root}>
                <div className={s.container}>
                    <div className={s.heading}>
                        <MessageCircle size={24} />
                        <h1 className={s.title}>{title}</h1>
                    </div>

                    <p className={s.description}>
                        Configura los mensajes de error que se muestran cuando un usuario intenta compartir información de contacto en el chat.
                        Estos mensajes se muestran en el idioma preferido del usuario.
                    </p>

                    {success && (
                        <Alert bsStyle="success">
                            ¡Mensajes guardados exitosamente!
                        </Alert>
                    )}

                    {error && (
                        <Alert bsStyle="danger">
                            {error}
                        </Alert>
                    )}

                    <form onSubmit={this.handleSubmit}>
                        {/* Phone Message */}
                        <Panel className={s.panel}>
                            <Panel.Heading>
                                <Panel.Title>📱 Mensaje para Números de Teléfono</Panel.Title>
                            </Panel.Heading>
                            <Panel.Body>
                                <MultiLanguageInput
                                    baseField="phoneMessage"
                                    values={this.state}
                                    onChange={this.handleChange}
                                    inputType="textarea"
                                    placeholder="Ej: No está permitido compartir números de teléfono..."
                                    disabled={isDataLoading || loading}
                                />
                            </Panel.Body>
                        </Panel>

                        {/* Email Message */}
                        <Panel className={s.panel}>
                            <Panel.Heading>
                                <Panel.Title>📧 Mensaje para Correos Electrónicos</Panel.Title>
                            </Panel.Heading>
                            <Panel.Body>
                                <MultiLanguageInput
                                    baseField="emailMessage"
                                    values={this.state}
                                    onChange={this.handleChange}
                                    inputType="textarea"
                                    placeholder="Ej: No está permitido compartir correos electrónicos..."
                                    disabled={isDataLoading || loading}
                                />
                            </Panel.Body>
                        </Panel>

                        {/* URL Message */}
                        <Panel className={s.panel}>
                            <Panel.Heading>
                                <Panel.Title>🔗 Mensaje para Enlaces/URLs</Panel.Title>
                            </Panel.Heading>
                            <Panel.Body>
                                <MultiLanguageInput
                                    baseField="urlMessage"
                                    values={this.state}
                                    onChange={this.handleChange}
                                    inputType="textarea"
                                    placeholder="Ej: No está permitido compartir enlaces externos..."
                                    disabled={isDataLoading || loading}
                                />
                            </Panel.Body>
                        </Panel>

                        <div className={s.submitContainer}>
                            <Button
                                bsStyle="primary"
                                type="submit"
                                disabled={loading || isDataLoading}
                                className={s.submitBtn}
                            >
                                <Save size={16} />
                                <span>{loading ? 'Guardando...' : 'Guardar Cambios'}</span>
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const GET_CONTENT_FILTER_MESSAGES = gql`
  query getContentFilterMessages {
    getContentFilterMessages {
      status
      errorMessage
      phoneMessage_es
      phoneMessage_en
      phoneMessage_fr
      phoneMessage_it
      phoneMessage_pt
      emailMessage_es
      emailMessage_en
      emailMessage_fr
      emailMessage_it
      emailMessage_pt
      urlMessage_es
      urlMessage_en
      urlMessage_fr
      urlMessage_it
      urlMessage_pt
    }
  }
`;

const UPDATE_CONTENT_FILTER_MESSAGES = gql`
  mutation updateContentFilterMessages(
    $phoneMessage_es: String,
    $phoneMessage_en: String,
    $phoneMessage_fr: String,
    $phoneMessage_it: String,
    $phoneMessage_pt: String,
    $emailMessage_es: String,
    $emailMessage_en: String,
    $emailMessage_fr: String,
    $emailMessage_it: String,
    $emailMessage_pt: String,
    $urlMessage_es: String,
    $urlMessage_en: String,
    $urlMessage_fr: String,
    $urlMessage_it: String,
    $urlMessage_pt: String
  ) {
    updateContentFilterMessages(
      phoneMessage_es: $phoneMessage_es,
      phoneMessage_en: $phoneMessage_en,
      phoneMessage_fr: $phoneMessage_fr,
      phoneMessage_it: $phoneMessage_it,
      phoneMessage_pt: $phoneMessage_pt,
      emailMessage_es: $emailMessage_es,
      emailMessage_en: $emailMessage_en,
      emailMessage_fr: $emailMessage_fr,
      emailMessage_it: $emailMessage_it,
      emailMessage_pt: $emailMessage_pt,
      urlMessage_es: $urlMessage_es,
      urlMessage_en: $urlMessage_en,
      urlMessage_fr: $urlMessage_fr,
      urlMessage_it: $urlMessage_it,
      urlMessage_pt: $urlMessage_pt
    ) {
      status
      errorMessage
    }
  }
`;

export default compose(
    withStyles(s),
    graphql(GET_CONTENT_FILTER_MESSAGES, {
        options: { fetchPolicy: 'network-only' }
    }),
    graphql(UPDATE_CONTENT_FILTER_MESSAGES, { name: 'updateContentFilterMessages' })
)(ChatFilterMessages);
